import { accountSettingsStoreState } from 'models/account-settings/account-settings.store'
import { useEditProfile } from './useEditProfile'
import { useNotification } from 'hooks/use-notification/useNotification'
import { useFileUpload } from 'hooks/use-file-upload/useFileUpload'
import { useFileDragEvents } from 'hooks/use-file-drag-events/useFileDragEvents'
import { useState } from 'react'

export const useAddResume = (setIsContainerVisible: Function) => {
  const {
    fileName,
    setFileName,
    showConfirmDeleteResume,
    setShowConfirmDeleteResume,
    resumeLoading,
    setResumeLoading
  } = accountSettingsStoreState
  const { editProfileQuestions, updatedQuestionAnswers, completeEditOnboarding } = useEditProfile()
  const { getProcessedFile } = useFileUpload()
  const { notify } = useNotification()
  const { handleDrop, handleDrag, handleDragIn } = useFileDragEvents()
  const uploadedResume = editProfileQuestions?.find(x => x.question.includes('resume'))
  const uploadedFileName = editProfileQuestions?.find(x => x.question.includes('resume filename'))
  const showQuestion = editProfileQuestions?.find(x => x.question.includes('Show Resume'))
  const [resume, setResume] = useState<string>(editProfileQuestions?.find(x => x.question === 'resume')?.userAnswer)

  const handleUpload = (e: any, fileHandler: 'drag' | 'upload') => {
    setResumeLoading(true)
    const files = fileHandler === 'drag' ? e.dataTransfer.files : e.target.files
    const options = ['pdf', 'doc', 'docx']
    const maxImageFileSize = 5
    const fsMb = files[0]?.size / (1024 * 1024)
    if (fsMb > maxImageFileSize) {
      notify('error', 'Upload limit for a resume is 5MB')
      e.target.value = ''
      setFileName('')
      setResumeLoading(false)
      return
    }

    if (!options.includes(files[0]?.name?.toLowerCase()?.split('.')[files[0]?.name?.split('.')?.length - 1])) {
      notify('error', `File types supported are only pdf & doc`)
      e.target.value = ''
      setFileName('')
      setResumeLoading(false)
      return
    }

    getProcessedFile(files, ['pdf', 'doc', 'docx', 'jpeg', 'jpg', 'png'], 'stream', async ({ file }: any) => {
      const resume = editProfileQuestions.find(x => x.question === 'resume')
      const fileNameArray = files[0]?.name.split('.')
      if (resume) {
        resume.userAnswer = JSON.stringify({ file: file, type: fileNameArray[fileNameArray.length - 1] })
        editProfileQuestions[editProfileQuestions.indexOf(resume)] = resume
        uploadedFileName.userAnswer = files[0]?.name
        editProfileQuestions[editProfileQuestions.indexOf(uploadedFileName)] = uploadedFileName
      }
      setFileName(files[0]?.name)
      await completeEditOnboarding(updatedQuestionAnswers(editProfileQuestions)).then(updatedUser => {
        setResumeLoading(false)
        setIsContainerVisible(true)
        if (updatedUser?.onboardingQuestions?.length > 0) {
          setResume(updatedUser?.onboardingQuestions?.find(x => x.question === 'resume')?.answer)
        }
      })
      
      return
    })
  }

  const handleDeleteResume = async e => {
    const resume = editProfileQuestions?.find(x => x.question === 'resume')
    const resumeFilename = editProfileQuestions?.find(x => x.question === 'resume filename')
    resumeFilename.userAnswer = null
    resume.userAnswer = null
    editProfileQuestions[editProfileQuestions.indexOf(resumeFilename)] = resumeFilename
    editProfileQuestions[editProfileQuestions.indexOf(resume)] = resume
    e.target.value = ''
    setFileName('')
    await completeEditOnboarding(updatedQuestionAnswers(editProfileQuestions))
  }

  const handleShowResumeChange = async () => {
    showQuestion.userAnswer = showQuestion.userAnswer === 'true' ? 'false' : 'true'
    await completeEditOnboarding(updatedQuestionAnswers(editProfileQuestions))
  }

  const handleViewResume = () => {
    window.open('https://docs.google.com/gview?url=' + resume, '_blank')
  }
  return {
    fileName,
    setFileName,
    showConfirmDeleteResume,
    setShowConfirmDeleteResume,
    handleDeleteResume,
    uploadedFileName,
    uploadedResume,
    handleUpload,
    handleDrop,
    handleDrag,
    handleDragIn,
    showQuestion,
    handleShowResumeChange,
    handleViewResume,
    resumeLoading,
    notify
  } as const
}
